import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "show", "hide"]

  connect() {
    this.update()
  }

  update() {
    this.showTargets.forEach(element => {
      element.classList.toggle("hidden", !this.inputTarget.checked)
    })
    this.hideTargets.forEach(element => {
      element.classList.toggle("hidden", this.inputTarget.checked)
    })
  }
}
